import { classByStatus } from './workers-status-class';
import { isLoadingStatus } from './is-loading-status';

export { classByStatus, isLoadingStatus };
